/**
 * @generated SignedSource<<efe5cd7303cce063c3c1cc22a192e0ea>>
 * @relayHash c8147ea7d06264c113941f070cc9c557
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a

import type { ConcreteRequest } from 'relay-runtime';
export type getAutomatedMeetingNotesPagePropertiesQuery$variables = {
  pageAri: string;
};
export type getAutomatedMeetingNotesPagePropertiesQuery$data = {
  readonly page: {
    readonly id: string | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
  } | null | undefined;
};
export type getAutomatedMeetingNotesPagePropertiesQuery = {
  response: getAutomatedMeetingNotesPagePropertiesQuery$data;
  variables: getAutomatedMeetingNotesPagePropertiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "pageAri"
      }
    ],
    "concreteType": "Page",
    "kind": "LinkedField",
    "name": "page",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "keys",
            "value": [
              "isAutomatedMeetingNotes",
              "meetingRecurrenceAri"
            ]
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ],
        "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getAutomatedMeetingNotesPagePropertiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getAutomatedMeetingNotesPagePropertiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c8147ea7d06264c113941f070cc9c557",
    "id": "7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a",
    "metadata": {},
    "name": "getAutomatedMeetingNotesPagePropertiesQuery",
    "operationKind": "query",
    "text": "query getAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
  }
};
})();

(node as any).hash = "4187f33183c6b803fad92aa55dc76eee";

export default node;
